import * as React from "react";
import {TextFieldItem} from "./Fields/TextFieldItem";
import {CustomFieldItem} from "./Fields/CustomFieldItem";
import {SeparatorFieldItem} from "./Fields/SeparatorFieldItem";
import {LinkFieldItem} from "./Fields/LinkFieldItem";
import {FieldSummaryItem} from "./Fields/FieldSummaryItem";
import {Accordion} from "shared/controls/Accordion/Accordion";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {ImageField} from "./Fields/ImageField";
import {QRCodeFieldItem} from "PageBuilder/pagebuilder/tabs/FieldsTab/Fields/QRCodeFieldItem";
import {IconFieldItem} from "PageBuilder/pagebuilder/tabs/FieldsTab/Fields/IconFieldItem";
import {FigureFieldItem} from "PageBuilder/pagebuilder/tabs/FieldsTab/Fields/FigureFieldItem";
import {HtmlFieldItem} from "PageBuilder/pagebuilder/tabs/FieldsTab/Fields/HtmlFieldItem";
import {FieldItemBase} from "InternalShared/PageBuilder/Fields/FieldItemBase";
import {EventManager} from "shared/utilities/Events/EventManager";
import {GetAdvancedField} from "InternalShared/Events/GetAdvancedField";
import {TableFieledItem} from "PageBuilder/pagebuilder/tabs/FieldsTab/Fields/TableFieledItem";
import {FieldItem} from "PageBuilder/pagebuilder/tabs/FieldsTab/Fields/FieldItem";

export class FieldsTab extends React.Component<FieldsTabProps, FieldsTabState> {
    static defaultProps: Partial<FieldsTabProps> = {};
    public advancedField:FieldItemBase<any,any>[];
    constructor(props: FieldsTabProps) {
        super(props);
        this.state = {};
        this.advancedField=[];
        this.advancedField=EventManager.Publish(new GetAdvancedField(),[]);
    }

    public render() {
        return (
            <Accordion OpenOnlyOne={false}>
                <AccordionItem Title={'Standard'} IsOpen={true} Padding={0}>
                    <div style={{backgroundColor:'white'}}>
                        <TextFieldItem/>
                        <FieldItem/>
                        <SeparatorFieldItem/>
                        <LinkFieldItem/>
                        <FieldSummaryItem/>
                        <TableFieledItem/>
                    </div>
                </AccordionItem>
                <AccordionItem Title={'Advanced (full version required)'} IsOpen={false} Padding={0}>
                    <ImageField/>
                    <HtmlFieldItem/>
                    <QRCodeFieldItem/>
                    <IconFieldItem/>
                    <FigureFieldItem/>
                    <CustomFieldItem/>
                    {this.advancedField.map((x,index)=>
                        <React.Fragment key={index}>
                            {x}
                        </React.Fragment>
                    )}
                </AccordionItem>
            </Accordion>


        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldsTabProps {

}

interface FieldsTabState {

}

//#endregion "My Region"